<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style scoped>
 @import 'common/css/base.css';
 @import 'common/css/alert.css';
</style>



// WEBPACK FOOTER //
// src/App.vue